import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { Location } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
import { NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { GroupMasterService } from '../../../services/group-master.service';
import { TaskService } from '../../../services/task.service';
import { UserMasterService } from '../../../services/user-master.service';
import { ProcessMasterService } from '../../../services/process-master.service';
import { ActivatedRoute } from '@angular/router';
import { Enums } from '../../../helpers/enums';
import { CommonFunction } from '../../../helpers/commonFunction';
import { AlertComponent } from '../../alert/alert.component';
import { CustomValidation } from "../../../helpers/customValidation";
import { ComplianceMasterService } from '../../../services/compliance-master.service';
// import { DynamicFormService } from '../../../services/dynamicForm.service'
import { BranchAndDepartmentService } from '../../../services/branch-and-department.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Subject } from 'rxjs/Rx';
var moment = require('moment');

import * as _ from 'lodash';

declare var $: any;
declare var jQuery: any;
declare var autosize: any;
import { environment } from '../../../../environments/environment';
import { SharerService } from '../../../services/sharer.service';


@Component({
  selector: 'app-compliance-certificate-add',
  templateUrl: './compliance-certificate-add.component.html',
  styleUrls: ['./compliance-certificate-add.component.css']
})
export class ComplianceCertificateAddComponent implements OnInit {

  public environmentSettings: any;
  public minDate: Date;

  tasks: any[];
  meetingTypes: any[];
  groupTypes: any[];
  taskId: string;
  meetingtypeId: string;
  meetingType: string;
  departmentId: string;
  groupName: string;
  policyTypes: any[];
  riskTypes: any[];
  dateOptions: any[];
  departments: any[];
  users: any[];

  assignedusers: any[];
  escalation2Users: any[];
  escalation1Users: any[];
  escalation1ofResponsibleUsers: any[];
  escalation2ofResponsibleUsers: any[];
  responsibleUsers: any[];

  collegues: any[];
  taskTriggerTypes: any[];
  branchId: string;
  risktypeId: string;
  ActivationFromDateModel: NgbDateStruct;
  ActivationTillDateModel: NgbDateStruct;
  dueDateModel: NgbDateStruct;
  triggerType: string;
  processType: string;
  periodicityId: string;
  ProcessIdModel: any;
  afterTriggerDate: NgbDateStruct;
  processes: any[];
  processId: string;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  taskParticularsmodel: string;
  todaysDate: any;
  checkValidationInput: any;
  error: any = { isError: false, errorMessage: '' };
  reminderFrequencyError: any = { isError: false, errorMessage: '' };
  firstEscalationStartError: any = { isError: false, errorMessage: '' };
  secondEscalationStartError: any = { isError: false, errorMessage: '' };
  firstEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  secondEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  removeuserid: any;
  isPeriodicConfigurationAvailable: boolean = true;
  configAssignedUserId: any;
  disabledOnclick: boolean = false;
  fixedDateDateModel: NgbDateStruct;
  public ipLocalPc: any;
  taskUpdateType: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  //-----------------------------------------------------------------------------------------
  complianceCertificateForm: FormGroup;
  userList: any[];
  searchFilteredUsers: any[];
  selectedAll: any;
  IsSelectedUsers: any;
  selectedUserData = [];
  selectedUserList = [];
  selectedAllChecker: any;
  selectedCheckerUserData = [];
  selectedCheckerUserList = [];
  showAddedChecker: boolean = false;
  showAddedMaker: boolean = false;
  periodicityData: any[];
  complianceItems: any[];
  selectedComplianceData = [];
  selectedComplianceList = [];
  departmentList = [];
  branchList = [];
  selectedAllDepartments: any;
  selectedIndividualDeptData = [];
  selectedIndividualDeptList = [];
  selectedAllBranches: any;
  selectedIndividualBranchData = [];
  selectedIndividualBranchList = [];
  showEsc1Select: boolean = true;
  showEsc1Text: boolean = false;
  showEsc2Select: boolean = true;
  showEsc2Text: boolean = false;
  showAddedDept: boolean = false;
  showAddedBranch: boolean = false;
  currentURL: any;
  hasPermission: any;
  pageTitle: any;
  addOrUpdateBtn: boolean = true;
  complianceCertificateId: any;
  masterCertificateCreated: boolean = false;

  @ViewChild(DataTableDirective)
  dtOptionsForMaker: DataTables.Settings = {};
  dtTriggerForMaker: Subject<any> = new Subject();

  dtOptionsForComplianceItem: DataTables.Settings = {};
  dtTriggerForComplianceItem: Subject<any> = new Subject();

  dtOptionsForComplianceItemAdd: DataTables.Settings = {};
  dtTriggerForComplianceItemAdd: Subject<any> = new Subject();

  dtOptionsForDepartment: DataTables.Settings = {};
  dtTriggerForDepartment: Subject<any> = new Subject();

  dtOptionsForBranch: DataTables.Settings = {};
  dtTriggerForBranch: Subject<any> = new Subject();

  constructor(private taskService: TaskService, private router: Router, private route: ActivatedRoute, private customValidation: CustomValidation, private commonFunction: CommonFunction, private alert: AlertComponent,
    private sharerService: SharerService, private ComplianceMasterService: ComplianceMasterService, public branchAndDepartmentService: BranchAndDepartmentService, private location: Location) {


    this.currentURL = window.location.href;
    this.dateOptions = Enums.DateOptions;
    this.policyTypes = this.commonFunction.sortByKey(Enums.policyType, 'name');
    this.riskTypes = this.commonFunction.sortByKey(Enums.RiskTypes, 'name');
    this.departments = this.commonFunction.sortByKey(Enums.Departments, 'name');

  }

  getescalation2ResponsibleUsersList() {
    this.escalation2ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })

  }
  onActivationFromDateChange() {
    this.complianceCertificateForm.get('ActivationFromDate')?.setValue(this.ActivationFromDateModel);
  }

  onActivationTillDateChange() {
    this.complianceCertificateForm.get('activationTillDate')?.setValue(this.ActivationTillDateModel);
  }
  getescalation1ResponsibleUsersList() {
    this.escalation1ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');

          } else {
            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  getescalation1UsersList() {
    this.escalation1Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) {
                  return Item.ResourceType == "Escalation 1";
                });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1Users = this.commonFunction.sortByKey(userlist, 'FirstName');
            this.escalation1Users = this.escalation1Users.map(ele => {
              return {
                label: ele.FirstName + ' ' + ele.LastName,
                value: ele._id,
                ...ele
              }
            })
          } else {
            this.escalation1Users = this.commonFunction.sortByKey(result.result, 'FirstName');
            this.escalation1Users = this.escalation1Users.map(ele => {
              return {
                label: ele.FirstName + ' ' + ele.LastName,
                value: ele._id,
                ...ele
              }
            })
          }
        }
      })

  }

  getescalation2UsersList() {
    this.escalation2Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2Users = this.commonFunction.sortByKey(userlist, 'FirstName');
            this.escalation2Users = this.escalation2Users.map(ele => {
              return {
                label: ele.FirstName + ' ' + ele.LastName,
                value: ele._id,
                ...ele
              }
            })
          }
          else {
            this.escalation2Users = this.commonFunction.sortByKey(result.result, 'FirstName');
            this.escalation2Users = this.escalation2Users.map(ele => {
              return {
                label: ele.FirstName + ' ' + ele.LastName,
                value: ele._id,
                ...ele
              }
            })
          }
        }
      })
  }

  getassignedUsersList() {
    this.assignedusers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.assignedusers = this.commonFunction.sortByKey(userlist, 'FirstName');
            for (let i in this.assignedusers) {
              this.assignedusers[i].isDisable = false;
            }
          } else {
            this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  getresponsibleUsersList() {
    this.responsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.responsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.responsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  getUsersList() {
    this.users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.users = this.commonFunction.sortByKey(result.result, 'FirstName');
          for (let i in this.users) {
            this.users[i].isDisable = false;
          }
        }
      })
  }

  onChange(value) {
    if (value) {
      this.complianceCertificateForm.controls['Escalation1ofResponsibleUser'].enable();
      this.complianceCertificateForm.controls['Escalation2ofResponsibleUser'].enable();


    }
    else {
      this.complianceCertificateForm.controls['Escalation1ofResponsibleUser'].disable();
      this.complianceCertificateForm.controls['Escalation2ofResponsibleUser'].disable();
      this.complianceCertificateForm.controls['Escalation1ofResponsibleUser'].setValue('');
      this.complianceCertificateForm.controls['Escalation2ofResponsibleUser'].setValue('');

    }

  }

  onSelectMemberDisableFromOther() {

    let colleguesToId = this.complianceCertificateForm.controls['Collegues'].value;
    let assignedToId = this.complianceCertificateForm.controls['AssignedTo'].value;
    let escalation1ofAssignedTo = this.complianceCertificateForm.controls['Escalation1ofAssignedTo'].value;
    let escalation2ofAssignedTo = this.complianceCertificateForm.controls['Escalation2ofAssignedTo'].value;
    this.assignedusers.forEach(element => {
      if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
        element.isDisable = true;
      } else {
        element.isDisable = false;
      }
    });

    this.collegues.forEach(element => {
      if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
        element.isDisable = true;
      } else {
        element.isDisable = false;
      }
    });

    this.escalation1Users.forEach(element => {
      if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
        element.isDisable = true;
      } else {
        element.isDisable = false;
      }
    });

    this.escalation2Users.forEach(element => {
      if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
        element.isDisable = true;
      } else {
        element.isDisable = false;
      }
    });


  }

  selectUserTeam(assignedUserId) {
    console.log(assignedUserId.value)
    this.taskService.getUserDetailsByAssignedUser(assignedUserId.value).subscribe(response => {
      if (response.data.length > 0) {
        console.log(response.data)
        this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(response.data[0].escalation2.userId);
        this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(response.data[0].escalation1.userId);
        this.complianceCertificateForm.controls.Collegues.setValue(response.data[0].colleague.userId);

        console.log(this.complianceCertificateForm.controls.Escalation2ofAssignedTo)
      } else {
        this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(null);
        this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(null);
        this.complianceCertificateForm.controls.Collegues.setValue(null);
      }
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);

    }
    return null;
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  GetcomplianceCertificateFormInput() {
    if (this.complianceCertificateForm.status == "VALID") {
      var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
      var companyID = companyDetails.companyID;
      var checkGlobal = true;
      var companyId;
      if (this.complianceCertificateForm.controls.certificateFor.value == 'Company') {
        checkGlobal = false
        companyId = companyID;
      }
      else {
        companyId = null;
      }
      var checkTasktrigger = null;
      if (this.complianceCertificateForm.controls.TriggerType.value == 'Event') {
        checkTasktrigger = 1
      }
      if (this.complianceCertificateForm.controls.TriggerType.value == 'Periodic') {
        checkTasktrigger = 2
      }

      var processId = null;
      if (this.complianceCertificateForm.controls.ProcessID.value != '') {
        processId = this.complianceCertificateForm.controls.ProcessID.value;
      }
      let approveStatus = true;
      if (environment.TaskMakerChecker) {
        approveStatus = false;
      }
      console.log('approveStatus', approveStatus)
      var newTask = {
        CertificateName: this.complianceCertificateForm.controls.CertificateName.value.trim(),
        TaskDescription: this.complianceCertificateForm.controls.TaskDescription.value.trim(),
        departmentId: this.complianceCertificateForm.controls.departmentId.value,
        certificateFor: checkGlobal,

        MeetingTypeID: (this.complianceCertificateForm.controls.meetingtypeId.value == "") ? null : this.complianceCertificateForm.controls.meetingtypeId.value,
        ReminderDays: (this.complianceCertificateForm.controls.ReminderDays.value == "") ? 0 : this.complianceCertificateForm.controls.ReminderDays.value,
        ReminderPeriod: this.complianceCertificateForm.controls.ReminderFrequency.value,
        EscalationDays: this.complianceCertificateForm.controls.EscalationDays.value,
        Level2EscalationDays: this.complianceCertificateForm.controls.Level2EscalationDays.value,
        CompletionDays: (this.complianceCertificateForm.controls.CompletionDays.value == "") ? 0 : this.complianceCertificateForm.controls.CompletionDays.value,
        TriggerType: checkTasktrigger,
        TriggerID: this.complianceCertificateForm.controls.periodicityId.value,
        DateOption: parseInt(this.complianceCertificateForm.controls.DateOption.value),

        EmailSendForTask: this.complianceCertificateForm.controls.Email.value,
        ReminderPeriodLevel1: this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value,
        ReminderPeriodLevel2: this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value,

        EmailContents: this.complianceCertificateForm.controls.EmailContents.value,

        PolicyType: parseInt(this.complianceCertificateForm.controls.branchId.value),
        RiskType: parseInt(this.complianceCertificateForm.controls.risktypeId.value),
        PreConsequences: this.complianceCertificateForm.controls.PreConsequences.value,
        UserConsequences: this.complianceCertificateForm.controls.UserConsequences.value,
        AssignedTo: (this.complianceCertificateForm.controls.AssignedTo.value == "") ? null : this.complianceCertificateForm.controls.AssignedTo.value,
        ResponsibleUser: (this.complianceCertificateForm.controls.ResponsibleUser.value == "") ? null : this.complianceCertificateForm.controls.ResponsibleUser.value,
        IsActive: true,
        IsPredefined: false,
        Escalation1ofAssignedTo: (this.complianceCertificateForm.controls.Escalation1ofAssignedTo.value == "") ? null : this.complianceCertificateForm.controls.Escalation1ofAssignedTo.value,
        Escalation2ofAssignedTo: (this.complianceCertificateForm.controls.Escalation2ofAssignedTo.value == "") ? null : this.complianceCertificateForm.controls.Escalation2ofAssignedTo.value,
        Escalation1ofResponsibleUser: (this.complianceCertificateForm.controls.Escalation1ofResponsibleUser.value == "") ? null : this.complianceCertificateForm.controls.Escalation1ofResponsibleUser.value,
        Escalation2ofResponsibleUser: (this.complianceCertificateForm.controls.Escalation2ofResponsibleUser.value == "") ? null : this.complianceCertificateForm.controls.Escalation2ofResponsibleUser.value,
        Collegues: (this.complianceCertificateForm.controls.Collegues.value == "") ? null : this.complianceCertificateForm.controls.Collegues.value,
        CompanyID: companyId,
        TriggerStartDate: this.setDate(this.complianceCertificateForm.controls.ActivationFromDate.value),
        activationTillDate: this.setDate(this.complianceCertificateForm.controls.activationTillDate.value),
        TaskParticulars: (this.complianceCertificateForm.controls.TaskParticulars.value != null || this.complianceCertificateForm.controls.TaskParticulars.value != undefined) ? this.complianceCertificateForm.controls.TaskParticulars.value.trim() : this.complianceCertificateForm.controls.TaskParticulars.value,
        ProcessID: processId,
        DefaultAssignedTo: this.configAssignedUserId,
        FixedDate: this.setDate(this.complianceCertificateForm.controls.fixedDate.value),
        isApproved: approveStatus,
        IPAddress: this.ipLocalPc,
        type: this.taskUpdateType
      }

      return newTask;
    }
    else {
      return null;
    }
  }

  addTask(type) {
    this.taskUpdateType = type;
    this.disabledOnclick = true;
    if (this.isPeriodicConfigurationAvailable == true) {
      var taskDetail = this.GetcomplianceCertificateFormInput();

      var todayDate = moment(new Date()).format("MM-DD-YYYY");
      var triggerStartDate = taskDetail.TriggerStartDate != null && taskDetail.TriggerStartDate != undefined ? moment(taskDetail.TriggerStartDate).format("MM-DD-YYYY") : "";

      if (triggerStartDate == todayDate && environment.TaskMakerChecker == false) {
        this.disabledOnclick = false;
        $('#taskParticularsDialog').modal('toggle');
      } else {
        if (triggerStartDate == todayDate) {
          this.taskUpdateType = 'addAndActivate';
        }

        this.taskService.addTask(taskDetail)
          .subscribe(task => {
            this.disabledOnclick = false;
            if (task.status == 0) {
              if (environment.TaskMakerChecker == true) {
                this.alert.successWithOk("Task is added successfully and pending for Checker's approval", '/tasks/library');
              } else {
                this.alert.successWithOk(task.message, '/tasks/library');
              }
            }
            else {
              if (task.err_fields != undefined) {
                this.alert.error(JSON.stringify(task.err_fields) + ' fields are required or invalid.');
              } else {
                this.alert.error(task.message);
              }
            }

          });
      }
    } else {
      this.alert.error('Please add default configurations for periodic tasks');
    }


  }


  addTaskandActivate() {
    this.disabledOnclick = true;
    var taskDetail = this.GetcomplianceCertificateFormInput();
    this.taskService.addandActivateTask(taskDetail)
      .subscribe(task => {
        this.disabledOnclick = false;
        if (task.status == 0) {
          $('#taskParticularsDialog').modal('hide');
          this.alert.successWithOk(task.message, '/tasks/activated');
        }
        else {
          $('#taskParticularsDialog').modal('hide');

          if (task.err_fields != undefined) {
            this.alert.error(JSON.stringify(task.err_fields) + ' fields are required or invalid.');
          } else {
            this.alert.error(task.message);
          }
        }

      });

  }

  addTasktoProcess() {
    if (this.complianceCertificateForm.controls.ProcessID.value) {
      this.disabledOnclick = true;
      var taskDetail = this.GetcomplianceCertificateFormInput();
      this.taskService.addTask(taskDetail)
        .subscribe(task => {
          this.disabledOnclick = false;
          if (task.status == 0) {
            $('#addtasktoprocessDialog').modal('toggle');
            const processId = this.complianceCertificateForm.controls.ProcessID.value;

            this.alert.successWithOk(task.message, '/process/edit/' + processId);

          }
          else {
            $('#addtasktoprocessDialog').modal('toggle');

            if (task.err_fields != undefined) {
              this.alert.error(JSON.stringify(task.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(task.message);
            }
          }

        });

    } else {
      this.alert.error("Please select Process");
    }

  }

  reset() {
    $('#resetConfirmation').modal('toggle');
  }

  resetFormData() {
    this.complianceCertificateForm.reset();
    $('#resetConfirmation').modal('toggle');
    this.ngOnInit();
  }


  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;

    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode == 109) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 2 digits
      if ((ev.target.value + ev.key).length > 5) {
        ev.preventDefault();
      }

    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  showSelectedTriggerID(triggertype) {
    if (this.complianceCertificateForm.controls.TriggerType.value != triggertype) {
      this.complianceCertificateForm.controls.periodicityId.setValue('');
    }
  }

  IsTriggerTypeSelected(name: any): boolean {

    if (!this.triggerType) { // if no radio button is selected, always return false so every nothing is shown  
      return false;
    }

    return (this.triggerType === name); // if current radio button is selected, return true, else return false  
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
  }

  checkRemindersValidation() {

    var reminderStartDays = (this.complianceCertificateForm.controls.ReminderDays.value != null || this.complianceCertificateForm.controls.ReminderDays.value != undefined) ? this.complianceCertificateForm.controls.ReminderDays.value : 0;
    var reminderFrequency = (this.complianceCertificateForm.controls.ReminderFrequency.value != null || this.complianceCertificateForm.controls.ReminderFrequency.value != undefined) ? this.complianceCertificateForm.controls.ReminderFrequency.value : 0;
    var firstEscalationStart = (this.complianceCertificateForm.controls.EscalationDays.value != null || this.complianceCertificateForm.controls.EscalationDays.value != undefined) ? this.complianceCertificateForm.controls.EscalationDays.value : 0;
    var secondEscalationStart = (this.complianceCertificateForm.controls.Level2EscalationDays.value != null || this.complianceCertificateForm.controls.Level2EscalationDays.value != undefined) ? this.complianceCertificateForm.controls.Level2EscalationDays.value : 0;
    var firstEscalationreminderfrequency = (this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value != null || this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value != undefined) ? this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value : 0;
    var secondEscalationreminderfrequency = (this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value != null || this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value != undefined) ? this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value : 0;

    //Created by Roshan --messages not cleared if date is valid 
    if (reminderStartDays != "" || reminderStartDays !== null) {
      if (parseInt(reminderStartDays) < parseInt(reminderFrequency)) {
        this.checkValidationInput = true;
        this.reminderFrequencyError = {
          isError: true, errorMessage: 'Reminder frequency cannot be more than reminder start date.'
        };
        return false;
      }
      else if (parseInt(reminderStartDays) < parseInt(firstEscalationStart)) {
        this.checkValidationInput = true;
        this.firstEscalationStartError = {
          isError: true, errorMessage: '1st Escalation start cannot be more than Reminder start date.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(secondEscalationStart)) {
        this.checkValidationInput = true;
        this.secondEscalationStartError = {
          isError: true, errorMessage: '2nd Escalation start cannot be more than 1st Escalation start.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(firstEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.firstEscalationreminderFrequencyError = {
          isError: true, errorMessage: '1st Escalation reminder frequency cannot be more than 1st Escalation start date.'
        };
        return false;
      }
      else if (parseInt(secondEscalationStart) < parseInt(secondEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.secondEscalationreminderFrequencyError = {
          isError: true, errorMessage: '2nd Escalation reminder frequency cannot be more than 2nd Escalation start date.'
        };
        return false;
      }

      else {
        this.checkValidationInput = false;
        this.reminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };

      }
    }
    else {
      this.error = { isError: false, errorMessage: '' }
    }
    return true;
  }


  ngOnInit() {
    this.minDate = new Date();
    this.dropdownList = [
      { "id": 1, "itemName": "India" },
      { "id": 2, "itemName": "Singapore" },
      { "id": 3, "itemName": "Australia" },
      { "id": 4, "itemName": "Canada" },
      { "id": 5, "itemName": "South Korea" },
      { "id": 6, "itemName": "Germany" },
      { "id": 7, "itemName": "France" },
      { "id": 8, "itemName": "Russia" },
      { "id": 9, "itemName": "Italy" },
      { "id": 10, "itemName": "Sweden" }
    ];
    this.selectedItems = [
      { "id": 2, "itemName": "Singapore" },
      { "id": 3, "itemName": "Australia" },
      { "id": 4, "itemName": "Canada" },
      { "id": 5, "itemName": "South Korea" }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class"
    };

    this.environmentSettings = environment;

    this.getPeriodictyData();
    this.getDeptAndBranchMasterData('RegisterDepartmentMaster')
    this.getDeptAndBranchMasterData('RegisterBranchMaster')
    this.getUserList()

    this.getescalation2ResponsibleUsersList();
    this.getescalation1ResponsibleUsersList();
    this.getescalation2UsersList();
    this.getescalation1UsersList();
    this.getassignedUsersList();
    this.getresponsibleUsersList();

    this.initialiseJqueryEvents();

    this.getUsersList();

    // this.sharerService.getClientIp().subscribe((response) => {
    //   console.log('responseresponseresponse', JSON.parse(response['_body']))
    //   var ip = JSON.parse(response['_body']).ip;
    //   this.ipLocalPc = ip
    // });


    console.log(this.currentURL)
    if (this.currentURL.includes('edit')) {
      this.pageTitle = 'Edit Compliance Certificate';
      this.route.params.subscribe(params => {
        this.getComplianceCertificateById(params['id']);
        this.complianceCertificateId = params['id'];
      });
      this.addOrUpdateBtn = false;
    } else {
      this.pageTitle = 'Add Compliance Certificate';
      this.addOrUpdateBtn = true;
    }

    this.complianceCertificateForm = new FormGroup({
      CertificateName: new FormControl('', [Validators.required, Validators.maxLength(250), this.customValidation.noWhitespaceValidator]),
      certificateFor: new FormControl('', [Validators.required]),
      departmentId: new FormControl('', []),
      branchId: new FormControl('', []),
      submittedBy: new FormControl('', []),
      authorizeBy: new FormControl('', []),
      authorizationRequired: new FormControl('', []),
      dueDays: new FormControl('', [Validators.min(0)]),
      periodicityId: new FormControl('', [Validators.required]),
      ReminderDays: new FormControl(null, [Validators.required, Validators.pattern('[0-9]*'), Validators.min(0)]),
      ReminderFrequency: new FormControl(null, [Validators.required, Validators.pattern('[0-9]*'), Validators.min(0)]),
      EscalationDays: new FormControl(null, [Validators.required, Validators.pattern('[0-9]*'), Validators.min(0)]),
      Level2EscalationDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.min(0)]),
      ReminderFrequencyLevel1: new FormControl(null, [Validators.required, Validators.pattern('[0-9]*'), Validators.min(0)]),
      ReminderFrequencyLevel2: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.min(0)]),
      Escalation1ofAssignedTo: new FormControl('', []),
      Escalation1Email: new FormControl('', []),
      Escalation2ofAssignedTo: new FormControl('', []),
      Escalation2Email: new FormControl('', []),
      ActivationFromDate: new FormControl('', [Validators.required]),
      activationTillDate: new FormControl('', []),

    });

    this.dtOptionsForMaker = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [2] }],
    };

    this.dtOptionsForComplianceItem = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [2] }],
    };

    this.dtOptionsForComplianceItemAdd = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
    };

    this.dtOptionsForDepartment = {
      destroy: true,

      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [] }],
    };

    this.dtOptionsForBranch = {
      destroy: true,
      // scrollY: "250px",
      // scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [] }],
    };


    this.getTodaysDate();

    $('#CertificateName').focus();

  }

  getUserList() {
    this.showAddedChecker = false;
    this.showAddedMaker = false;
    this.selectedUserData = [];
    this.selectedCheckerUserList = [];
    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.userList = [];
          var table1 = $('#makerTable').DataTable({ destroy: true });
          var table2 = $('#checkerTable').DataTable({ destroy: true });
          table1.destroy();
          table2.destroy();
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.userList = this.commonFunction.sortByKey(userlist, 'FirstName');
            for (let i in this.userList) {
              this.userList[i].isDisable = false;
            }
            this.dtTriggerForMaker.next();
          } else {
            this.userList = this.commonFunction.sortByKey(result.result, 'FirstName');
            this.dtTriggerForMaker.next();
          }
        }
      })
  }


  checkIfAllSelected(event) {

    console.log(this.userList)
    if (event.target.checked == true) {

      this.userList.forEach(element => {
        console.log(element.selectedMakerUser)
        if (!element.selectedMakerUser || element.selectedMakerUser == undefined) {

          let index = this.selectedUserData.indexOf(element._id);
          if (index == -1) {
            this.selectedUserData.push(element._id);
            this.selectedUserList.push(element);
          }

          element.selectedMakerUser = true;

        }
      });
    } else {
      this.userList.forEach(element => {
        if (element.selectedMakerUser != true) {
          let index = this.selectedUserData.indexOf(element._id);
          if (index > -1) {
            this.selectedUserData.splice(index, 1);
            this.selectedUserList.splice(index, 1);
          }
          element.selectedMakerUser = false;

        }
      });
    }
    console.log(this.selectedUserData)
  }

  checkSelected(event, index, userId, element) {
    if (event.target.checked == true) {

      this.selectedUserData.push(userId);
      this.selectedUserList.push(element);
    } else {

      let index = this.selectedUserData.indexOf(userId);
      if (index > -1) {
        this.selectedUserData.splice(index, 1);
        this.selectedUserList.splice(index, 1);
      }
    }

    console.log(this.selectedUserData)
  }

  checkIfAllSelectedChecker(event) {

    console.log(this.userList)
    if (event.target.checked == true) {

      this.userList.forEach(element => {
        console.log(element.selectedCheckerUser)
        if (!element.selectedCheckerUser || element.selectedCheckerUser == undefined) {

          let index = this.selectedCheckerUserData.indexOf(element._id);
          if (index == -1) {
            this.selectedCheckerUserData.push(element._id);
            this.selectedCheckerUserList.push(element);
          }

          element.selectedCheckerUser = true;

        }
      });
    } else {
      this.userList.forEach(element => {
        if (element.selectedCheckerUser != true) {
          let index = this.selectedCheckerUserData.indexOf(element._id);
          if (index > -1) {
            this.selectedCheckerUserData.splice(index, 1);
            this.selectedCheckerUserList.splice(index, 1);
          }
          element.selectedCheckerUser = false;

        }
      });
    }
    console.log(this.selectedCheckerUserData)
  }

  checkSelectedChecker(event, index, userId, element) {
    if (event.target.checked == true) {


      this.selectedCheckerUserData.push(userId);
      this.selectedCheckerUserList.push(element);
    } else {

      let index = this.selectedCheckerUserData.indexOf(userId);
      if (index > -1) {
        this.selectedCheckerUserData.splice(index, 1);
        this.selectedCheckerUserList.splice(index, 1);
      }
    }

    console.log(this.selectedCheckerUserData)
  }

  addDeptBranch(type) {
    if (type == 'dept') {
      this.showAddedDept = true;
    }
    if (type == 'branch') {
      this.showAddedBranch = true;
    }
  }

  getPeriodictyData() {
    this.periodicityData = [];
    this.ComplianceMasterService.getPeriodicityData()
      .subscribe((response: any) => {
        if (response.status == 0) {
          this.periodicityData = response.data;
        }
      })
  }

  getComplianceItemList() {
    this.complianceItems = [];
    this.ComplianceMasterService.getComplianceItemList()
      .subscribe(response => {
        if (response.status == 0) {
          this.complianceItems = response.data;
          this.dtTriggerForComplianceItemAdd.next();
        }
      })
  }

  checkIfAllComplianceSelected(event) {
    if (event.target.checked == true) {

      this.complianceItems.forEach(element => {
        if (!element.isSelected || element.isSelected == undefined) {

          let index = this.selectedComplianceData.indexOf(element._id);
          if (index == -1) {
            this.selectedComplianceData.push(element._id);
            this.selectedComplianceList.push(element);
          }

          element.isSelected = true;
          // element.transferToGemTime = Date.now()
          // this.countAgenda++;
        }
      });
    } else {
      this.complianceItems.forEach(element => {
        console.log(element.isSelected)
        let index = this.selectedComplianceData.indexOf(element._id);
        if (index > -1) {
          this.selectedComplianceData.splice(index, 1);
          this.selectedComplianceList.splice(index, 1);
        }
        element.isSelected = false;
      });
    }
    console.log(this.selectedComplianceData)
  }

  checkSelectedCompliance(event, index, userId, element) {
    if (event.target.checked == true) {

      // this.userList[index].transferToGemTime = Date.now();
      // this.countAgenda++;
      this.selectedComplianceData.push(userId);
      this.selectedComplianceList.push(element);
    } else {
      // this.userList[index].transferToGemTime = null;
      // this.countAgenda--;
      let index = this.selectedComplianceData.indexOf(userId);
      if (index > -1) {
        this.selectedComplianceData.splice(index, 1);
        this.selectedComplianceList.splice(index, 1);
      }
    }
    // this.selectedAgenda = this.ComplianceList.every(function (item: any) {
    //   return item.isPublished == true;
    // })
    console.log(this.selectedComplianceData)
  }

  clearSelectedCompliance() {
    this.complianceItems.forEach(element => {
      element.isSelected = false;
      this.selectedComplianceData = [];
      this.selectedComplianceList = [];
    });
  }

  getDeptAndBranchMasterData(collectionName) {
    if (collectionName == "RegisterDepartmentMaster") {
      this.departmentList = [];
      var table2 = $('#deptTable1').DataTable({ destroy: true });
      table2.destroy();
      this.branchAndDepartmentService.getDepartment().subscribe((response: any) => {
        if (response.status == 0) {
          this.departmentList = response.data;
          this.dtTriggerForDepartment.next();
        }
      })
    } else if (collectionName == "RegisterBranchMaster") {
      this.branchAndDepartmentService.getBranch().subscribe((response: any) => {
        if (response.status == 0) {
          var table2 = $('#deptTable2').DataTable({ destroy: true });
          table2.destroy();
          this.branchList = [];
          this.branchList = response.data;
          this.dtTriggerForBranch.next();
        }
      })
    }
  }

  selectAllDepts(event) {
    if (event.target.checked == true) {
      this.departmentList.forEach(element => {
        if (!element.selectedDept || element.selectedDept == undefined) {
          let index = this.selectedIndividualDeptData.indexOf(element._id);
          if (index == -1) {
            this.selectedIndividualDeptData.push(element._id);
            this.selectedIndividualDeptList.push(element);
          }
          element.selectedDept = true;
        }
      });
    } else {
      this.departmentList.forEach(element => {
        element.selectedDept = false;
        if (element.selectedDept != true) {
          let index = this.selectedIndividualDeptData.indexOf(element._id);
          if (index > -1) {
            this.selectedIndividualDeptData.splice(index, 1);
            this.selectedIndividualDeptList.splice(index, 1);
          }
        }
      });
    }
    console.log(this.selectedIndividualDeptData)
  }

  selectIndividualDept(event, index, deptId, element) {
    if (event.target.checked == true) {
      this.selectedIndividualDeptData.push(deptId);
      this.selectedIndividualDeptList.push(element);
    } else {
      let index = this.selectedIndividualDeptData.indexOf(deptId);
      if (index > -1) {
        this.selectedIndividualDeptData.splice(index, 1);
        this.selectedIndividualDeptList.splice(index, 1);
      }
    }
    console.log(this.selectedIndividualDeptData)
  }

  selectAllBranches(event) {
    if (event.target.checked == true) {
      this.branchList.forEach(element => {
        if (!element.selectedBranch || element.selectedBranch == undefined) {
          let index = this.selectedIndividualBranchData.indexOf(element._id);
          if (index == -1) {
            this.selectedIndividualBranchData.push(element._id);
            this.selectedIndividualBranchList.push(element);
          }
          element.selectedBranch = true;
        }
      });
    } else {
      this.branchList.forEach(element => {
        element.selectedBranch = false;
        if (element.selectedBranch != true) {
          let index = this.selectedIndividualBranchData.indexOf(element._id);
          if (index > -1) {
            this.selectedIndividualBranchData.splice(index, 1);
            this.selectedIndividualBranchList.splice(index, 1);
          }
        }
      });
    }
    console.log(this.selectedIndividualBranchData)
  }

  selectIndividualBranch(event, index, deptId, element) {
    if (event.target.checked == true) {
      this.selectedIndividualBranchData.push(deptId);
      this.selectedIndividualBranchList.push(element);
    } else {
      let index = this.selectedIndividualBranchData.indexOf(deptId);
      if (index > -1) {
        this.selectedIndividualBranchData.splice(index, 1);
        this.selectedIndividualBranchList.splice(index, 1);
      }
    }
    console.log(this.selectedIndividualBranchData)
  }

  setDefaultEscalation(param1, param2) {
    let esc1Id, esc2Id;
    let escl1Email, escl2Email;
    if (param2 == 'Individual') {
      this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(null);
      this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(null);
    } else if (param2 == 'Particular') {
      this.taskService.getUserDetailsByAssignedUser(param1).subscribe(response => {
        if (response.data.length > 0 && response.data[0].escalation1.length > 0) {
          console.log(response.data)
          esc1Id = response.data[0].escalation1.map(function (ele) {
            return ele.userId
          })
          escl1Email = response.data[0].escalation1.map(function (ele) {
            return ele.emailId
          });
          this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(esc1Id);
          this.complianceCertificateForm.controls.Escalation1Email.setValue(escl1Email);
          this.showEsc1Select = true;
          this.showEsc1Text = false;
          console.log(esc1Id)
          console.log(escl1Email)

        } else {
          if (this.complianceCertificateForm.controls.departmentId.value != null) {
            var filteredDept = this.departmentList.filter((element) => {
              return element._id == this.complianceCertificateForm.controls.departmentId.value
            })
            if (filteredDept.length > 0) {
              esc1Id = null;
              escl1Email = filteredDept[0].Escalation1;
            }
          }

          if (this.complianceCertificateForm.controls.branchId.value != null) {
            var filteredBranch = this.branchList.filter((element) => {
              return element._id == this.complianceCertificateForm.controls.branchId.value
            })
            if (filteredBranch.length > 0) {
              esc1Id = null;
              escl1Email = filteredBranch[0].Escalation1;
            }
          }
          this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(esc1Id);
          this.complianceCertificateForm.controls.Escalation1Email.setValue(escl1Email);
          this.showEsc1Text = true;
          this.showEsc1Select = false;
          console.log(esc1Id)
          console.log(filteredBranch)
        }
        if (response.data.length > 0 && response.data[0].escalation2.userId != "" && response.data[0].escalation2.userId != null && response.data[0].escalation2.userId != undefined) {
          console.log(response.data)
          esc2Id = response.data[0].escalation2.userId;
          escl2Email = response.data[0].escalation2.emailId;

          this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(esc2Id);
          this.complianceCertificateForm.controls.Escalation2Email.setValue(escl2Email);
          this.showEsc2Select = true;
          this.showEsc2Text = false;
        } else {
          if (this.complianceCertificateForm.controls.departmentId.value != null) {
            var filteredDept = this.departmentList.filter((element) => {
              return element._id == this.complianceCertificateForm.controls.departmentId.value
            })
            if (filteredDept.length > 0) {
              esc2Id = null;
              escl2Email = filteredDept[0].Escalation2;
            }
          }

          if (this.complianceCertificateForm.controls.branchId.value != null) {
            var filteredBranch = this.branchList.filter((element) => {
              return element._id == this.complianceCertificateForm.controls.branchId.value
            })
            if (filteredBranch.length > 0) {
              esc2Id = null;
              escl2Email = filteredBranch[0].Escalation2;
            }
          }
          this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(esc2Id);
          this.complianceCertificateForm.controls.Escalation2Email.setValue(escl2Email);
          this.showEsc2Select = false;
          this.showEsc2Text = true;
        }
      })
    } else if (param2 == 'All') {
      if (this.complianceCertificateForm.controls.departmentId.value != null) {
        var filteredDept = this.departmentList.filter((element) => {
          return element._id == this.complianceCertificateForm.controls.departmentId.value
        })
        if (filteredDept.length > 0) {
          esc2Id = null;
          escl2Email = filteredDept[0].Escalation2;
          esc1Id = null;
          escl1Email = filteredDept[0].Escalation1;
        }
      }

      if (this.complianceCertificateForm.controls.branchId.value != null) {
        var filteredBranch = this.branchList.filter((element) => {
          return element._id == this.complianceCertificateForm.controls.branchId.value
        })
        if (filteredBranch.length > 0) {
          esc2Id = null;
          escl2Email = filteredBranch[0].Escalation2;
          esc1Id = null;
          escl1Email = filteredDept[0].Escalation1;
        }
      }
      this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(esc2Id);
      this.complianceCertificateForm.controls.Escalation2Email.setValue(escl2Email);
      this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(esc1Id);
      this.complianceCertificateForm.controls.Escalation1Email.setValue(escl1Email);
    }
  }

  addComplianceCertificate(activationType) {
    var addObject = {
      CertificateName: this.complianceCertificateForm.controls.CertificateName.value,
      certificateFor: this.complianceCertificateForm.controls.certificateFor.value,
      dueDays: this.complianceCertificateForm.controls.dueDays.value,
      departmentId: this.complianceCertificateForm.controls.departmentId.value,
      periodicityId: this.complianceCertificateForm.controls.periodicityId.value,
      ReminderDays: this.complianceCertificateForm.controls.ReminderDays.value,
      ReminderFrequency: this.complianceCertificateForm.controls.ReminderFrequency.value,
      EscalationDays: this.complianceCertificateForm.controls.EscalationDays.value,
      Level2EscalationDays: this.complianceCertificateForm.controls.Level2EscalationDays.value,
      ReminderFrequencyLevel1: this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value,
      ReminderFrequencyLevel2: this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value,
      branchId: this.complianceCertificateForm.controls.branchId.value,
      Escalation1ofAssignedTo: this.complianceCertificateForm.controls.Escalation1ofAssignedTo.value,
      Escalation1Email: this.complianceCertificateForm.controls.Escalation1Email.value,
      Escalation2ofAssignedTo: this.complianceCertificateForm.controls.Escalation2ofAssignedTo.value,
      Escalation2Email: this.complianceCertificateForm.controls.Escalation2Email.value,
      ActivationFromDate: this.setDate(this.complianceCertificateForm.controls.ActivationFromDate.value),
      activationTillDate: this.setDate(this.complianceCertificateForm.controls.activationTillDate.value),
      submittedBy: this.complianceCertificateForm.controls.submittedBy.value,
      authorizeBy: this.complianceCertificateForm.controls.authorizeBy.value,
      authorizationRequired: this.complianceCertificateForm.controls.authorizationRequired.value,
      departmentList: this.selectedIndividualDeptData,
      branchList: this.selectedIndividualBranchData,
      selectedComplianceList: this.selectedComplianceList,
      ipAddress: this.ipLocalPc,
      masterCertificateCreated: activationType
    }
    this.ComplianceMasterService.addComplianceCertificate(addObject).subscribe(response => {
      if (response.status == 0) {
        if (activationType == false) {
          this.alert.successWithOk1("Compliance certificate added successfully", () => {
             this.router.navigate(
      [{ outlets: { 'structure-outlet': ['complianceCertificateList']  } }],
      { relativeTo: this.route.parent });
          // this.router.navigateByUrl('/structure/(structure-outlet:complianceCertificateList)');
          })
        } else if (activationType == true) {
          this.alert.successWithOk1("Compliance certificate added successfully", () => {
             this.router.navigate(
      [{ outlets: { 'structure-outlet': ['activatedComplianceCertificate']  } }],
      { relativeTo: this.route.parent });
              // this.router.navigateByUrl('/structure/(structure-outlet:activatedComplianceCertificate)');
          })
        }
      }
    })
  }

  back() {
    this.ngOnInit();
    this.location.back(); // Navigate back to the previous page
  }

  getComplianceCertificateById(id) {
    this.ComplianceMasterService.getComplianceCertificateById(id).subscribe(response => {
      if (response.status == 0) {
        let responseData = response.data[0];
        this.masterCertificateCreated = responseData.masterCertificateCreated;
        this.complianceCertificateForm.controls.CertificateName.setValue(responseData.CertificateName)
        this.complianceCertificateForm.controls.certificateFor.setValue(responseData.certificateFor)
        this.complianceCertificateForm.controls.dueDays.setValue(responseData.dueDays)
        this.complianceCertificateForm.controls.departmentId.setValue(responseData.departmentId)
        this.complianceCertificateForm.controls.periodicityId.setValue(responseData.periodicityId)
        this.complianceCertificateForm.controls.ReminderDays.setValue(responseData.ReminderDays)
        this.complianceCertificateForm.controls.ReminderFrequency.setValue(responseData.ReminderFrequency)
        this.complianceCertificateForm.controls.EscalationDays.setValue(responseData.EscalationDays)
        this.complianceCertificateForm.controls.Level2EscalationDays.setValue(responseData.Level2EscalationDays)
        this.complianceCertificateForm.controls.ReminderFrequencyLevel1.setValue(responseData.ReminderFrequencyLevel1)
        this.complianceCertificateForm.controls.ReminderFrequencyLevel2.setValue(responseData.ReminderFrequencyLevel2)
        this.complianceCertificateForm.controls.branchId.setValue(responseData.branchId)
        this.complianceCertificateForm.controls.Escalation1ofAssignedTo.setValue(responseData.Escalation1ofAssignedTo)
        this.complianceCertificateForm.controls.Escalation1Email.setValue(responseData.Escalation1Email)
        this.complianceCertificateForm.controls.Escalation2ofAssignedTo.setValue(responseData.Escalation2ofAssignedTo)
        this.complianceCertificateForm.controls.Escalation2Email.setValue(responseData.Escalation2Email)
        if (responseData.ActivationFromDate != null) {
          let dt = new Date(this.setFormatDate(responseData.ActivationFromDate));
          this.complianceCertificateForm.controls.ActivationFromDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() })
        }
        if (responseData.activationTillDate != null) {
          let dt = new Date(this.setFormatDate(responseData.activationTillDate));
          this.complianceCertificateForm.controls.activationTillDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() })
        }


        this.complianceCertificateForm.controls.submittedBy.setValue(responseData.submittedBy)
        this.complianceCertificateForm.controls.authorizeBy.setValue(responseData.authorizeBy)
        this.complianceCertificateForm.controls.authorizationRequired.setValue(responseData.authorizationRequired)
        if (responseData.departmentList.length > 0) {
          if (responseData.certificateFor == 'Individual' || responseData.certificateFor == 'All') {
            this.showAddedDept = true;
          }
          this.selectedIndividualDeptData = responseData.departmentList;
          let filteredDepts = this.departmentList.filter((element) => {
            return responseData.departmentList.includes(element._id);
          })
          this.selectedIndividualDeptList = filteredDepts
        }

        if (responseData.branchList.length > 0) {
          if (responseData.certificateFor == 'Individual' || responseData.certificateFor == 'All') {
            this.showAddedBranch = true;
          }
          this.selectedIndividualBranchData = responseData.branchList;
          let filteredBranchs = this.branchList.filter((element) => {
            return responseData.branchList.includes(element._id);
          })
          this.selectedIndividualBranchList = filteredBranchs
        }
        if (responseData.selectedComplianceList.length > 0) {
          this.selectedComplianceList = responseData.selectedComplianceList;
          this.selectedComplianceList.forEach((element) => {
            this.selectedComplianceData.push(element._id)
          })
        }
      }
    })
  }
  removeComplianceItem(id) {
    let index = this.selectedComplianceData.indexOf(id);
    if (index > -1) {
      this.selectedComplianceData.splice(index, 1);
      this.selectedComplianceList.splice(index, 1);
    }
  }

  updateComplianceCertificate(activationType) {
    var addObject = {
      CertificateName: this.complianceCertificateForm.controls.CertificateName.value,
      certificateFor: this.complianceCertificateForm.controls.certificateFor.value,
      dueDays: this.complianceCertificateForm.controls.dueDays.value,
      departmentId: this.complianceCertificateForm.controls.departmentId.value,
      periodicityId: this.complianceCertificateForm.controls.periodicityId.value,
      ReminderDays: this.complianceCertificateForm.controls.ReminderDays.value,
      ReminderFrequency: this.complianceCertificateForm.controls.ReminderFrequency.value,
      EscalationDays: this.complianceCertificateForm.controls.EscalationDays.value,
      Level2EscalationDays: this.complianceCertificateForm.controls.Level2EscalationDays.value,
      ReminderFrequencyLevel1: this.complianceCertificateForm.controls.ReminderFrequencyLevel1.value,
      ReminderFrequencyLevel2: this.complianceCertificateForm.controls.ReminderFrequencyLevel2.value,
      branchId: this.complianceCertificateForm.controls.branchId.value,
      Escalation1ofAssignedTo: this.complianceCertificateForm.controls.Escalation1ofAssignedTo.value,
      Escalation1Email: this.complianceCertificateForm.controls.Escalation1Email.value,
      Escalation2ofAssignedTo: this.complianceCertificateForm.controls.Escalation2ofAssignedTo.value,
      Escalation2Email: this.complianceCertificateForm.controls.Escalation2Email.value,
      ActivationFromDate: this.setDate(this.complianceCertificateForm.controls.ActivationFromDate.value),
      activationTillDate: this.setDate(this.complianceCertificateForm.controls.activationTillDate.value),
      submittedBy: this.complianceCertificateForm.controls.submittedBy.value,
      authorizeBy: this.complianceCertificateForm.controls.authorizeBy.value,
      authorizationRequired: this.complianceCertificateForm.controls.authorizationRequired.value,
      departmentList: this.selectedIndividualDeptData,
      branchList: this.selectedIndividualBranchData,
      selectedComplianceList: this.selectedComplianceList,
      ipAddress: this.ipLocalPc,
      masterCertificateCreated: activationType
    }
    this.ComplianceMasterService.updateComplianceCertificate(addObject, this.complianceCertificateId).subscribe(response => {
      if (response.status == 0) {
        this.alert.success('Compliance certificate updated successfully')
      }
    })
  }

  showSelectedDept() {
    this.departmentList.forEach((element) => {
      if (this.selectedIndividualDeptData.includes(element._id)) {
        element.selectedDept = true;
      }
    })
  }

  showSelectedBranch() {
    this.branchList.forEach((element) => {
      if (this.selectedIndividualBranchData.includes(element._id)) {
        element.selectedBranch = true;
      }
    })
  }

  resetOtherOption(from) {
    if (from == "Department") {
      this.complianceCertificateForm.controls.branchId.setValue("")
      this.selectedIndividualBranchData = []
      this.selectedIndividualBranchList = []
    } else if (from == "Branch") {
      this.complianceCertificateForm.controls.departmentId.setValue("")
      this.selectedIndividualDeptData = []
      this.selectedIndividualDeptList = []
    }
  }

  resetOnTypeChange() {
    this.selectedIndividualDeptList = [];
    this.showAddedDept = true;
  }
}